import { styled } from 'styled-components';

import { typography } from '@/styles/helpers';

export const ScPageDescription = styled.h2`
  max-width: 462px;
  margin: 0 auto;
  ${typography['body1regular']}
  text-align: center;
  color: ${({ theme }) => theme.whiteColor};
`;
